import type { Address } from '@strata-monorepo/shared-ui/types/Address'

export interface ErcotAddress {
  readonly address: string
  readonly city: string
  readonly esiid: string
  readonly meterType: string
  readonly premiseType: string
  readonly state: string
  readonly status: string
  readonly switchHold: boolean
  readonly utilityId: string
  readonly zipCode: string
}

export function mapErcotToAddress(ercot: ErcotAddress): Address {
  return {
    street_line: ercot.address,
    city: ercot.city,
    state: ercot.state,
    zipcode: ercot.zipCode,
  }
}
